import * as types from './ActionTypes';

const INITIAL_STATE = {
    isFetching: false,
    location: null
};

const resetToInitialState = () => INITIAL_STATE;

const requestHERELocation = (state) => {
    return {
        ...state,
        isFetching: true
    };
};

const receiveHERELocation = (state, data) => {
    return {
        ...state,
        isFetching: false,
        location: data.location,
        lastUpdated: data.receivedAt
    };
};

export const getHERELocation = (state) => {
    return {
        location: state.HERELocation.location || null
    };
};

const handlers = {
    [types.RECEIVE_HERE_LOCATION]: receiveHERELocation,
    [types.RESET_HERE_LOCATION]: resetToInitialState
};

export default function HERELocation(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;

    return handler(state, action);
}
